module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-right-fill-abd1bee2.svg";